import React, { useState } from "react";
import { createPortal } from 'react-dom';
import { Tooltip } from "react-tooltip";

import styles from "@/views/components/TooltipIcon/TooltipIcon.module.scss";

const TooltipIcon = ({ text, tooltipText, size = 16, color = "#FFF", textColor = "#000" }) => {
	const [ randomId ] = useState(String(Math.random()));

	return (
		<div
			data-tooltip-id={ `icon-tooltip-${randomId}` } 
			data-tooltip-html={ tooltipText }
			data-tooltip-place="top"
			data-html="true"
			className={ styles["tooltip-icon"] }
			style={ { display: 'flex', gap: '8px' } }
		>
			<div style={ { width: size, height: size } }>
				<svg 
					width={ size }  
					height={ size + 1 } 
					viewBox={ `0 0 ${ size } ${ size + 1 }` }
					xmlns="http://www.w3.org/2000/svg"
				>
					<path 
						d="M8 0.5C3.58166 0.5 0 4.08178 0 8.5C0 12.9185 3.58166 16.5 8 16.5C12.4183 16.5 16 12.9185 16 8.5C16 4.08178 12.4183 0.5 8 0.5ZM8 4.5C8.55231 4.5 9 4.94775 9 5.5C9 6.0525 8.55231 6.5 8 6.5C7.44769 6.5 7 6.0525 7 5.5C7 4.94775 7.44769 4.5 8 4.5ZM9.5 12.5H6.5C6.22388 12.5 6 12.2764 6 12C6 11.7239 6.22388 11.5 6.5 11.5H7V8.5H6.5C6.22388 8.5 6 8.27637 6 8C6 7.72388 6.22388 7.5 6.5 7.5H8.5C8.77612 7.5 9 7.72388 9 8V11.5H9.5C9.77612 11.5 10 11.7239 10 12C10 12.2764 9.77612 12.5 9.5 12.5Z" 
						fill={ color }
					/>
				</svg>
			</div>
			<span style={ { color: textColor } }>{ text }</span>
			{createPortal(
				<Tooltip 
					id={ `icon-tooltip-${randomId}` } 
					className={ styles["tooltip-container"] }
				/>, 
				document.body,
			)}
		</div>
	);
};

export default TooltipIcon;